import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import {isFloat} from 'validator';

// Components
import Select from "../../../components/common/virtualized-select";

// Actions
import { createProduct } from "../../../actions/products";
import { getSuppliers } from "../../../actions/suppliers";

class NewProduct extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            canAddSupplier: false,
            selectedSupplier: {
                _id: -1,
                name: 'Selecciona un Proveedor'
            },
            newCategoryLabel: '',
            product_code: '',
            name: '',
            desc: '',
            category_labels: List([]),
            unit_of_measure: '',
            vat: '',
            to_buy: true,
            is_generic: false,
            suppliers: List([]),
            price_alert: false,
            price_alert_threshold: ''
        };
    }

    componentDidUpdate(prevProps) {
        const { suppliersList } = this.props;
        const { suppliersList: prevSuppliersList }  = prevProps;

        if (suppliersList && suppliersList !== prevSuppliersList) {
            if (suppliersList.size > 0) {
                this.setState({
                    canAddSupplier: true
                });
            }
        }
    }

    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validateProduct);
    };

    onChangeSuppliers = () => {
        const { suppliers } = this.state;

        if (!suppliers.some(supplier => supplier.get('is_default') === true)) {
            this.onChangeDefaultSupplier(false, 0)
        }
    };

    onChangeDefaultSupplier = (defaultValue, i) => {
        let newSuppliers = List([]);

        this.state.suppliers.map( (supplier, j) => {
            const newDefault = j === i ? !defaultValue : defaultValue;

            return newSuppliers = newSuppliers.insert(newSuppliers.size, supplier.merge({ is_default: newDefault }));
        });
        this.setState({
            suppliers: newSuppliers
        });
    };

    addCategoryLabel = () => {
        const { category_labels, newCategoryLabel } = this.state;
        if (newCategoryLabel !== '') {
            this.setState({
                category_labels: category_labels.push(newCategoryLabel)
            }, () => this.setState({ newCategoryLabel: '' }));
        }
    };

    deleteCategoryLabel = (index) => {
        this.setState({
            category_labels: this.state.category_labels.delete(index)
        });
    };

    validateProduct = () => {
        if (
            this.state.product_code !== '' &&
            this.state.name !== '' &&
            this.state.vat !== '' &&
            this.state.to_buy !== '' &&
            this.state.is_generic !== ''
        ) {
            this.setState({
                canSubmit: true
            });
        } else {
            this.setState({
                canSubmit: false
            });
        }
    };

    handleCreateClick = () => {
        const {
            product_code,
            name,
            desc,
            category_labels,
            unit_of_measure,
            vat,
            to_buy,
            is_generic,
            suppliers,
            price_alert,
            price_alert_threshold
        } = this.state;
        let newSuppliers = List([]);

        suppliers.map(supplier => newSuppliers = newSuppliers.insert(newSuppliers.size, supplier.delete('name')));

        this.props.createProduct({
            product_code,
            name,
            desc,
            category_labels: category_labels.toJS(),
            unit_of_measure,
            vat,
            to_buy,
            is_generic,
            suppliers: newSuppliers.toJS(),
            price_alert,
            price_alert_threshold
        });
        this.props.history.goBack();
    };

    render() {
        const {
            canSubmit,
            canAddSupplier,
            selectedSupplier,
            newCategoryLabel,
            product_code,
            name,
            desc,
            category_labels,
            unit_of_measure,
            vat,
            to_buy,
            is_generic,
            suppliers,
            price_alert,
            price_alert_threshold
        } = this.state;
        const { suppliersList } = this.props;
        const booleanOptions = [{ value: true, name: 'Sí' }, { value: false, name: 'No' }];
        let suppliersTable = 'No se ha añadido ningún proveedor para este producto.', filteredSuppliersList = List([]);

        suppliersList.map( supplierItem => {
                if(!suppliers.some(supplier => supplier.get('supplier') === supplierItem.get('_id'))) {
                    return filteredSuppliersList = filteredSuppliersList.insert(filteredSuppliersList.size, supplierItem);
                } else {
                    return null
                }
        });

        if (suppliers.size >= 1) {
            suppliersTable = (
                <div className="table-wrapper" >
                    <div className="row table-header-row">
                        <div className="col-3">
                            Nombre
                        </div>
                        <div className="col-6">
                            Referencia del proveedor
                        </div>
                        <div className="col-2 d-flex justify-content-center">
                            ¿Proveedor de referencia?
                        </div>
                    </div>
                    {
                        suppliers.map( (supplier, i) => {
                            return (
                                <div className="row table-row" key={i} >
                                    <div className="col-3 d-flex align-items-center" style={{ fontSize: '0.9rem' }} >
                                        { supplier.get('name') }
                                    </div>
                                    <div className="col-6">
                                        <input
                                            className="form-control"
                                            type="text"
                                            value={supplier.get('reference')}
                                            onChange={ (event) => {
                                                this.setState({
                                                    suppliers: suppliers.set(i, supplier.merge({
                                                        reference: event.target.value
                                                    }))
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="col-2 d-flex justify-content-center align-items-center">
                                        <label className="radio-div">
                                            <input
                                                type="radio"
                                                checked={supplier.get('is_default')}
                                                onChange={ () => this.onChangeDefaultSupplier(supplier.get('is_default'), i) }
                                            />
                                            <span className="radio-btn"></span>
                                        </label>
                                    </div>
                                    <div className="col-1 d-flex justify-content-center align-items-center">
                                        <Icon
                                            className="cursor-pointer"
                                            icon="trash"
                                            onClick={ () => {
                                                this.setState({
                                                    suppliers: suppliers.remove(i)
                                                }, this.onChangeSuppliers);
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            )
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/productos">Productos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Nuevo Producto</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button
                                className="btn btn-cancel"
                                onClick={ () => this.props.history.goBack() }
                            >Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ () => this.handleCreateClick() }
                                disabled={!canSubmit}
                            >Crear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Código de Producto *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={product_code}
                                                    onChange={ (event) => this.onChangeInput('product_code', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label>Nombre *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={name}
                                                    onChange={ (event) => this.onChangeInput('name', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <div className="form-group">
                                                <label>Descripción</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={desc}
                                                    onChange={ (event) => this.onChangeInput('desc', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Etiquetas de categoría</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={newCategoryLabel}
                                                    onChange={ (event) => this.onChangeInput('newCategoryLabel', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-9" style={{ paddingTop: 25 }} >
                                            <button
                                                className="btn btn-custom"
                                                style={{ marginRight: 5 }}
                                                disabled={ newCategoryLabel === ''}
                                                onClick={ () => this.addCategoryLabel() } >
                                                Añadir etiqueta
                                            </button>
                                            { category_labels.map( (category, i) => {
                                                return <span key={i} className="badge badge-custom category-label">
                                            {category}
                                                    <Icon icon="cross" title="Eliminar" onClick={ () => this.deleteCategoryLabel(i) } />
                                        </span>
                                            })
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Unidad de medida</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={unit_of_measure}
                                                    onChange={ (event) => this.onChangeInput('unit_of_measure', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Tipo de IVA (%) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={vat}
                                                    onChange={ (event) => {
                                                        const newValue = event.target.value;

                                                        if ((isFloat(newValue) && newValue <= 100) || event.target.value === '') {
                                                            this.onChangeInput('vat', event.target.value);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>¿Producto comprable?</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={booleanOptions}
                                                    value={to_buy}
                                                    labelKey="name"
                                                    valueKey="value"
                                                    matchProp="name"
                                                    multi={false}
                                                    searchable={false}
                                                    clearable={false}
                                                    onChange={(valueSelected) => {
                                                        if (!valueSelected.value) {
                                                            this.setState({
                                                                suppliers: List([])
                                                            });
                                                        }
                                                        this.onChangeInput('to_buy', valueSelected.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>¿Producto genérico?</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={booleanOptions}
                                                    value={is_generic}
                                                    labelKey="name"
                                                    valueKey="value"
                                                    matchProp="name"
                                                    multi={false}
                                                    searchable={false}
                                                    clearable={false}
                                                    onChange={(valueSelected) => this.onChangeInput('is_generic', valueSelected.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <h4>Seguimiento de precio
                                        <Icon
                                            icon="info-sign"
                                            style={{ margin: '2px 6px' }}
                                            title="Dispara una alerta cuando el precio de compra del producto supera el % máximo marcado respecto al anterior precio de compra registrado"
                                        />
                                    </h4>
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>¿Alertar de aumento de precio?</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={booleanOptions}
                                                    value={price_alert}
                                                    labelKey="name"
                                                    valueKey="value"
                                                    matchProp="name"
                                                    multi={false}
                                                    searchable={false}
                                                    clearable={false}
                                                    onChange={(valueSelected) => this.onChangeInput('price_alert', valueSelected.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Porcentaje de aumento máximo (%)</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={price_alert_threshold}
                                                    onChange={ (event) => {
                                                        const newValue = event.target.value;
                                                        if (isFloat(newValue) || newValue === '') {
                                                            this.onChangeInput('price_alert_threshold', event.target.value);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    { to_buy
                                        ? <div>
                                            <div className="row" style={{ marginBottom: 15 }} >
                                                <div className="col d-flex justify-content-between">
                                                    <h4>Proveedores</h4>
                                                    { canAddSupplier
                                                        ? (
                                                            <div className="d-inline-flex justify-content-end">
                                                                <Select
                                                                    className="virtualized-select"
                                                                    style={{ width: 400, marginRight: 10 }}
                                                                    options={filteredSuppliersList.toJS()}
                                                                    value={selectedSupplier._id}
                                                                    labelKey="name"
                                                                    valueKey="_id"
                                                                    matchProp="name"
                                                                    multi={false}
                                                                    searchable={true}
                                                                    clearable={false}
                                                                    onChange={(valueSelected) => {
                                                                        if (valueSelected) {
                                                                            this.onChangeInput('selectedSupplier', valueSelected);
                                                                        }
                                                                    }}
                                                                />
                                                                <button
                                                                    className="btn btn-custom"
                                                                    disabled={ selectedSupplier && selectedSupplier._id === -1 }
                                                                    onClick={ () => {
                                                                        this.setState({
                                                                            selectedSupplier: {
                                                                                _id: -1,
                                                                                name: 'Selecciona un Proveedor'
                                                                            },
                                                                            suppliers: suppliers.insert(suppliers.size, Map({
                                                                                supplier: selectedSupplier._id,
                                                                                name: selectedSupplier.basic_info.name,
                                                                                reference: '',
                                                                                is_default: false
                                                                            }))
                                                                        }, this.onChangeSuppliers);
                                                                    }}
                                                                >
                                                                    Añadir
                                                                </button>
                                                            </div>
                                                        )
                                                        : (
                                                            <button
                                                                className="btn btn-custom"
                                                                onClick={ () => this.props.getSuppliers({
                                                                    projection: 'supplier_code basic_info.name',
                                                                    deleteVirtuals: true
                                                                }) }

                                                            >
                                                                Añadir Proveedor
                                                            </button>
                                                        )

                                                    }
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">{suppliersTable}</div>
                                            </div>
                                        </div>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const suppliersReducer = state.suppliers;

    // Suppliers
    const suppliers = suppliersReducer.get('payload') || List([]);
    let suppliersList = List([]);

    suppliersList = suppliersList.insert(suppliersList.size, Map({
        _id: -1,
        name: 'Selecciona un Proveedor'
    }));

    suppliers.map( supplier => {
        return suppliersList = suppliersList.insert(suppliersList.size,
            supplier
                .set('name', `[${supplier.get('supplier_code')}] ${supplier.getIn(['basic_info','name'])}`)
                .delete('supplier_code')
            )
    });

    return {
        suppliersList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createProduct: (product) => dispatch(createProduct(product)),
        getSuppliers: (query) => dispatch(getSuppliers(query))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewProduct);



// WEBPACK FOOTER //
// ./src/containers/configuration/products/NewProduct.js